module.exports = __webpack_public_path__ + "static/media/1200px-RecaptchaLogo.14982d21.png";